var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-icon-button",class:_vm.buttonStyle},[_c('span',{staticClass:"state-layer"},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }